<template>
  <div class="login-card__register-email-card">
    <div class="login-card__title-box">
      <h1 class="login-card__title">{{ trans.get('auth.card.register.email.header') }}</h1>
      <!--            <p class="login-card__title-desc" v-html="trans.get('auth.card.registration_agreement', {link1: zRoute('page.agb'), link2: zRoute('page.privacy')})"></p>-->
      <!--            <p class="login-card__title-desc login-card__title-desc&#45;&#45;disclaimer">{{trans.get('auth.card.registration_disclaimer')}}</p>-->
    </div>
    <div>
      <validation-observer ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="form-group">
            <validation-provider name="email" rules="required" v-slot="{ errors }" mode="eager">
              <label for="email"></label>
              <input
                type="email"
                id="email"
                class="input-text__underline"
                v-model="form.email"
                placeholder="user@example.com"
              >
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>

          </div>
          <div class="form-group">
            <validation-provider name="password" rules="required" v-slot="{ errors }" mode="eager">
              <div class="input-group is-invalid">
                <label for="password"></label>
                <input :type="passwordInputType" id="password" class="form-control input-text input-text__underline" v-model="form.password" :placeholder="trans.get('auth.card.fields.password')">
                <div class="input-group-append">
                  <button type="button" class="button__password-eye" @click="switchPasswordVisibility"><i class="fa fa-eye" aria-hidden="true"></i></button>
                </div>
              </div>
              <span class="text-danger">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <button type="submit" class="button button__fill button--w-100 mt-3 text--smedium">{{ trans.get('auth.card.buttons.register_continue') }}</button>
        </form>
      </validation-observer>

      <button type="button" class="button button__link button__link--underline mt-3 text--smedium" @click="swapComponent('auth-welcome-card')">{{ trans.get('auth.card.buttons.back') }}</button>
    </div>

    <button type="button" class="button button__link button__link--blue text--smedium" @click="swapComponent('auth-welcome-card')"><i class="demo-icon icon-facebook pr-1"> </i>
      {{ trans.get('auth.card.welcome.facebook_button') }}
    </button>

    <p class="login-card__btn-desc">{{ trans.get('auth.card.registration_footer') }}</p>

  </div>
</template>
<script>
export default {
  props: ['swapComponent', 'form'],
  data: () => ({
    passwordInputType: 'password',
  }),
  methods: {
    switchPasswordVisibility() {
      this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
    },
    onSubmit() {
      const self = this;
      axios
        .post(zRoute('register'), {
          email: this.form.email,
          password: this.form.password,
          cid: window.localStorage.getItem('campaign_cid'),
          eid: window.localStorage.getItem('campaign_eid'),
          campaign_query: window.localStorage.getItem('campaign_query'),
        })
        .then(function (response) {
          if (response.data.status === 'success') {
            // if (window.globals.settings_verification_required) {
            if (response.data.verification_is_required) {
              self.swapComponent('auth-verification-email-card');
            } else {
              self.swapComponent('auth-name-card');
            }
          }
        }, function (error) {
          if (error.response.status === 422) {
            if (!('email' in error.response.data.errors || 'password' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
  }
};
</script>